import { Field, TextInput, NumberInput, TextArea, SectionHeader } from "./Field";

export default function StepResidence({ form, update }) {
  return (
    <div>
      <SectionHeader
        eyebrow="Chapter II"
        title="Your current residence."
        description="Where you live now, and how we may contact your current landlord."
      />

      <div className="space-y-6">
        <Field label="Current Address" required testid="field-current-address">
          <TextArea
            value={form.current_address}
            onChange={(v) => update({ current_address: v })}
            placeholder="Street, City, State, Zip"
            rows={2}
            testid="input-current-address"
          />
        </Field>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
          <Field label="Current Landlord Phone" required testid="field-landlord-phone">
            <TextInput
              type="tel"
              value={form.current_landlord_phone}
              onChange={(v) => update({ current_landlord_phone: v })}
              placeholder="(555) 123-4567"
              testid="input-landlord-phone"
            />
          </Field>
          <Field
            label="Years at Current Address"
            required
            testid="field-years-current"
          >
            <NumberInput
              value={form.years_at_current_address}
              onChange={(v) => update({ years_at_current_address: v })}
              placeholder="0"
              min={0}
              step="0.5"
              testid="input-years-current"
            />
          </Field>
        </div>
      </div>
    </div>
  );
}
